import "./Refined.module.css";
import Header from "@/reusable_sections/Header";
import CategoryHero from "./sections/CategoryHero";
import SubProductsGrid from "./sections/SubProductsGrid";
import Footer from "@/reusable_sections/Footer";
export default function RefinedPage() {
  return <div>
      <Header />
      <CategoryHero />
      <SubProductsGrid />
      <Footer />
    </div>;
}